import ACTION_TYPES from './actionTypes';
import initialState from './state';

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_DATA: {
      return action.data;
    }
    case ACTION_TYPES.UPDATE: {
      return {
        ...state,
        ...action.data
      };
    }
    case ACTION_TYPES.RESET: {
      return {
        ...state,
        ...action.data.reduce((acc, key) => {
          acc[key] = initialState[key];
          return acc;
        }, {})
      };
    }
    default: {
      return state;
    }
  }
};
